<template>
  <div id="app">
    <v-app>
      <main>
        <router-view/>
      </main>
        <!-- <router-link to="/">Home</router-link> -->
      <!-- <v-footer padless style="color:#FFFFFF;background-color:#222288;"> -->
      <v-footer padless style="color:#222288;">
        <v-col
          class="text-center"
          cols="12"
          color="#00000000"
        >
          {{ new Date().getFullYear() }} — <strong>Resistance Online</strong>
        </v-col>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
// import Home from '@/views/Home.vue'
// import HelloWorld from './components/HelloWorld.vue'
//
export default {
  name: 'App',
  components: {
  },
}
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
}
#app main {
  flex: 1;
}
.footer {
  margin-top: 12px;
}

.link {
  color: #5555BB;
  cursor:pointer;
}

</style>
